import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { AnalyticsData } from '../login-authentication-screen/models/login-credentials.interface';
import { unlockAccountView } from './models/unlockAccount.interface';

@Component({
  selector: 'idp-unlock-your-account',
  templateUrl: './unlock-your-account.component.html',
  styleUrls: ['./unlock-your-account.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UnlockYourAccountComponent implements OnInit {
  @Input() pageData: unlockAccountView | undefined | null;
  @Output() nextDisplayView: EventEmitter<string> = new EventEmitter<string>();
  @Output() redirectTrackingClick: EventEmitter<AnalyticsData> =
    new EventEmitter<AnalyticsData>();

  pageLoadStartTime: number;
  constructor() {
    this.pageLoadStartTime = performance.now();
  }

  ngOnInit() {
    if (this.pageLoadStartTime) {
      this.redirectTrackingClick.emit({
        action: 'Unlock Your Account',
        eventDetails: 'pageLoad',
        startTime: this.pageLoadStartTime
      });
    }
  }

  submitResetPassword() {
    const value =
      this.pageData?.unlockYourAccountView?.nextDisplayView
        ?.nextViewName_resetPassword;
    this.redirectTrackingClick.emit({ action: value });
    this.nextDisplayView.emit(value);
  }

  submitLoginHelp() {
    const value =
      this.pageData?.unlockYourAccountView?.nextDisplayView
        ?.nextViewName_loginHelp;
    this.redirectTrackingClick.emit({ action: value });
    this.nextDisplayView.emit(value);
  }
}
